module.exports = __webpack_public_path__ + "img/extended.71e1d9a2.png";